<div class="main-content py-2 px-0 px-lg-2">
  <div class="section-menu-items" #retailerMenu>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['allretailers']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate"> pages.newRetailer.manageRetailer</span>
      <mat-icon class="ms-2">supervisor_account</mat-icon>
    </button>
    <button
      [disabled]="isButtonDisabled"
      mat-flat-button
      class="item-each"
      [routerLink]="['addretailer']"
      routerLinkActive="router-link-active"
    >
      <span translate class="translate"> pages.sidebar.AddRetailer</span>
      <mat-icon class="ms-2">add_box</mat-icon>
    </button>
    <button
      mat-flat-button
      class="item-each"
      [routerLink]="['close-retailers']"
      routerLinkActive="router-link-active"
      *hideIfUnauthorized="'closeaccount'"
    >
      <span class="translate">{{'pages.CloseAccount.CloseAccount' | translate }}</span>
      <mat-icon class="ms-2">person_off</mat-icon>
    </button>
    
  <button mat-flat-button class="item-each" [routerLink]="['retailer-tiers']" routerLinkActive="router-link-active" *hideIfUnauthorized="'closeaccount'">
    <span class="translate">Retailer Tiers</span>
    <mat-icon class="ms-2">equalizer</mat-icon>
  </button>
  <button mat-flat-button class="item-each" [routerLink]="['retailer-requests']" routerLinkActive="router-link-active" 
  *hideIfUnauthorized="'closeaccount'" >
    <span class="translate">Retailer Requests</span>
    <mat-icon class="ms-2">person</mat-icon>
  </button>
  </div>
  <div class="scroll-control scrl-width">
    <button mat-mini-fab id="slideLeft" type="button" class="me-3" (click)="onClickLeft()"
      *hideIfUnauthorized="'scrollbuttons'">
      <mat-icon>arrow_left</mat-icon>
    </button>
    <button mat-mini-fab id="slideRight" type="button" (click)="onClickRight()" *hideIfUnauthorized="'scrollbuttons'">
      <mat-icon>arrow_right</mat-icon>
    </button>
  </div>
  <router-outlet></router-outlet>
</div>
